// extracted by mini-css-extract-plugin
export default {"card":"summary-card_card__ub2GM","icon":"summary-card_icon__2LA9m","title":"summary-card_title__b+9Yh"};